import { Loader } from "@googlemaps/js-api-loader";

const googleLoader = new Loader({
  apiKey: "AIzaSyB7UVtKu8nJdm7DALQQ__jDS6NE-4EPD1Q",
  version: "weekly",
  libraries: ["places"],
});

export default googleLoader
